import {IField, IFieldEdit} from '@core/api/data-access';

import {ValidatorTestResult} from '../entity-validator.types';

export namespace FieldValidator {
	export function validateFields(fields: (IFieldEdit | IField)[]): ValidatorTestResult {
		const result: ValidatorTestResult = {valid: true, errors: []};

		// Fields index - unique
		const fieldsIndex = fields?.map(field => field.index);
		const fieldsIndexSet = new Set(fieldsIndex);
		if (fieldsIndexSet.size !== fields?.length) {
			result.valid = false;
			result.errors?.push('Cycle fields must have unique index');
		}

		// TODO: add more validations

		return result;
	}
}
